import Vue from 'vue'
import confirm from './confirm.vue'

const ConfirmBox = Vue.extend(confirm);

confirm.install = (content, title, options) => {
    if (typeof title === 'object') {
        options = title;
        title = '提示';
    } else if (title === undefined) {
        title = '提示';
    }
  
    options = Object.assign({
        title: title,
        content: content,
    }, options);
  
    let instance = new ConfirmBox({
        data: options
    }).$mount();
  
    document.getElementById("malaContent").appendChild(instance.$el);
  
    return instance.confirm();
};
  
export default confirm


// WEBPACK FOOTER //
// ./src/components/confirm/confirm.js